// extracted by mini-css-extract-plugin
module.exports = {"personalize":"style_personalize__394-R","subtitle":"style_subtitle__nKhDb","content":"style_content__GFAyw"};